// Dans le menu du jeu, pour la personne qui a créé un monde raconté par son ChatGPT : le compte connecté,
// le dernier problème (limite atteinte…), reconnecter ou déconnecter.
import type { ClientView } from "../../shared/types";
import { send } from "../store";

export function ChatGptMenu({ view }: { view: ClientView }) {
  const link = view.chatgpt;
  if (!link || !view.me.isHost) return null;
  const who = link.account ? ` (${link.account})` : "";
  return (
    <div class="chatgpt-menu">
      <p class="chatgpt-menu-etat">
        {link.state === "probleme" ? `ChatGPT${who} : ${link.problem ?? "problème"}` : `Le Conteur écrit avec ton ChatGPT${who}.`}
      </p>
      <button
        type="button"
        class="btn btn-ghost game-menu-item"
        role="menuitem"
        onClick={() => {
          // reconnecter : on oublie l'ancien compte, l'écran de connexion s'ouvre avec un nouveau code
          send({ t: "chatgpt_disconnect" });
          send({ t: "chatgpt_connect" });
        }}
      >
        Reconnecter un compte ChatGPT
      </button>
    </div>
  );
}
